module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loggingOut":"Logging out..."}}')
  delete Component.options._Ctor
}
